const getChildren = (el, className) => {
  let children = null
  const descendants = el.querySelectorAll(`.${className}`)
  for (let i = 0; i < descendants.length; i++) {
    if (descendants[i].classList.contains(className)) {
      children = descendants[i];
      break;
    }
  }
  return children
}

export default {
  inserted(el, binding) {
    const height = getChildren(el, binding.value).offsetHeight
    el.style.height = `${height}px`
  },
  componentUpdated(el, binding) {
    setTimeout(() => {
      const child = getChildren(el, binding.value)
      if (child) {
        el.style.height = `${child.offsetHeight}px`
      }
    }, 1000)
  }
}
